export const modelDataTypeCheckerSymbol = Symbol("modelDataTypeChecker")
export const modelUnwrappedClassSymbol = Symbol("modelUnwrappedClass")
